import { gql } from '@apollo/client';

export const GET_TOKEN_LOCATIONS = gql`
  query GetTokenLocations($portfolioId: ID!) {
    tokenLocations(portfolioId: $portfolioId) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;
